import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import CompleteDeposit from "./completeDeposit";
import {connect} from "react-redux";
import Utils from "../../../custom/utils";
import Button from '@material-ui/core/Button';

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        //border:'2px solid ' + theme.navigation.selected.backgroundColor,
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class InboundDepositRow extends Component {
    completeDeposit = () => {
        let content = (
            <CompleteDeposit row={this.props.row} />
        );

        this.props.context.update({
            popupContent: content,
            popupTitle:"Complete Deposit"
        })
    }

    render() {
        const {classes} = this.props;
        return (
            <React.Fragment>

                        {(this.props.row._fund_type==='wire' && this.props.row._status <= 3 ) &&
                            <Button size="small" variant="outlined" color="primary" className={classes.debutton} onClick={this.completeDeposit}>{(!Utils.isEmpty(this.props.user.affiliate)&& this.props.row.investors[0]._affiliate === this.props.user.affiliate) ? "View" : "Complete"}</Button>
                        }

            </React.Fragment>
        )
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(InboundDepositRow))));
